"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5485],{

/***/ 85485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cards_grid_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/components/cards-grid-desktop/cards-grid-desktop-component.scss.js


var StyledCardsGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eo2z6qa0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;height:100%;margin:auto;display:flex;flex-wrap:wrap;justify-content:center;.grid-image-with-paragraph-component-wrapper{width:300px;margin:16px;}");

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/components/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var getGridImageWithParagraphProps = function(imageSrc, fullParagraphTitle, fullParagraphBody) {
    var fullParagraph = _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        fullParagraph: fullParagraph
    });
};
/* harmony default export */ var default_props = ({
    gridItems: [
        getGridImageWithParagraphProps("/static/img/card-grid/card-placeholder-image.png", "Cross-functional collab blog", "Look at your data differently with multiple View options from Calendar to Map."),
        getGridImageWithParagraphProps("/static/img/card-grid/card-placeholder-image.png", "Relevant story/video", "Automate repetitive tasks and have more time for the work that motivates you."),
        getGridImageWithParagraphProps("/static/img/card-grid/card-placeholder-image.png", "Productivity blog or marketing blog", "Get a high-level overview at a glance and make smarter decisions, faster.")
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.XS,
    textSize: sizes.MD
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/components/cards-grid-desktop/cards-grid-desktop-component.js




function cards_grid_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cards_grid_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cards_grid_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function cards_grid_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function cards_grid_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        cards_grid_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var IMAGE_HEIGHT = "100%";
var IMAGE_WIDTH = "100%";
var CardsGridDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CardsGridDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CardsGridDesktopComponent);
    function CardsGridDesktopComponent() {
        (0,_class_call_check/* default */.Z)(this, CardsGridDesktopComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CardsGridDesktopComponent, [
        {
            key: "renderGridItems",
            value: function renderGridItems() {
                var _props = this.props, gridItems = _props.gridItems, titleSize = _props.titleSize, textSize = _props.textSize;
                return gridItems.map(function(gridItem, index) {
                    var fullParagraph = gridItem.fullParagraph, resImageProps = _object_without_properties(gridItem, [
                        "fullParagraph"
                    ]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-image-with-paragraph-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image_with_paragraph/* default */.Z, cards_grid_desktop_component_object_spread_props(cards_grid_desktop_component_object_spread({}, resImageProps), {
                            fullParagraph: fullParagraph,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardsGridDesktopComponent, {
                    className: "cards-grid-desktop-component",
                    children: this.renderGridItems()
                });
            }
        }
    ]);
    return CardsGridDesktopComponent;
}(react.PureComponent);

CardsGridDesktopComponent.defaultProps = default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/components/cards-grid-mobile/cards-grid-mobile-component.scss.js



var StyledCardsGridMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewxmzea0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:0 24px;display:flex;flex-direction:column;justify-content:center;.grid-image-with-paragraph-component-wrapper{width:100%;height:101px;background-color:", colors/* default.white */.Z.white, ";box-shadow:0px 4px 40px rgba(0,0,0,0.08);margin:8px 0;display:flex;.inner-frame{display:flex;padding:8px;.grid-image-wrapper{height:100%;}.mobile-paragraph-wrapper{display:flex;flex-direction:column;justify-content:center;padding:0 12px;.title-wrapper{.title{font-weight:bold;font-size:1.069rem;line-height:24px;}}.button-wrapper{padding-top:8px;}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.grid-image-with-paragraph-component-wrapper{.inner-frame{.mobile-paragraph-wrapper{.title-wrapper{.title{font-weight:400;font-size:0.875rem;}}.button-wrapper{.secondary-button{font-size:0.8125rem;font-weight:400;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/components/cards-grid-mobile/cards-grid-mobile-component.js




function cards_grid_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cards_grid_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cards_grid_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function cards_grid_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function cards_grid_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        cards_grid_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function cards_grid_mobile_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = cards_grid_mobile_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function cards_grid_mobile_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var cards_grid_mobile_component_IMAGE_HEIGHT = "85px";
var cards_grid_mobile_component_IMAGE_WIDTH = "85px";
var CardsGridMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CardsGridMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CardsGridMobileComponent);
    function CardsGridMobileComponent() {
        (0,_class_call_check/* default */.Z)(this, CardsGridMobileComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CardsGridMobileComponent, [
        {
            key: "renderGridItems",
            value: function renderGridItems() {
                var gridItems = this.props.gridItems;
                return gridItems.map(function(gridItem, index) {
                    var _fullParagraph = gridItem.fullParagraph, fullParagraph = _fullParagraph === void 0 ? {} : _fullParagraph, resImageProps = cards_grid_mobile_component_object_without_properties(gridItem, [
                        "fullParagraph"
                    ]);
                    var title = fullParagraph.title, buttonConfig = fullParagraph.buttonConfig;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-image-with-paragraph-component-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inner-frame",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid-image-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, cards_grid_mobile_component_object_spread_props(cards_grid_mobile_component_object_spread({}, resImageProps), {
                                        width: cards_grid_mobile_component_IMAGE_WIDTH,
                                        height: cards_grid_mobile_component_IMAGE_HEIGHT
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mobile-paragraph-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "title-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "title",
                                                children: title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "button-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, cards_grid_mobile_component_object_spread({}, buttonConfig))
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardsGridMobileComponent, {
                    className: "cards-grid-mobile-component",
                    children: this.renderGridItems()
                });
            }
        }
    ]);
    return CardsGridMobileComponent;
}(react.PureComponent);

CardsGridMobileComponent.defaultProps = default_props;

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/cards-grid-component.js




var CardGridComponent = (0,responsive_hoc_component/* default */.Z)(CardsGridDesktopComponent, CardsGridMobileComponent);
/* harmony default export */ var cards_grid_component = (CardGridComponent);
CardGridComponent.defaultProps = default_props;


/***/ })

}]);